import React, { useState } from 'react'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import axios from 'axios';
import { useSelector } from 'react-redux';
import '../style/AddMethod.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import SwiperCore, { Pagination } from "swiper/core";
import "swiper/components/pagination/pagination.min.css";
import md5 from 'md5';
import { useNavigate } from 'react-router';

SwiperCore.use([Pagination]);

function AddMethod() {
    const navigate = useNavigate()
    const customerId = useSelector((user) => user.user.info.customer_id)
    const customerCode = useSelector((user) => user.user.info.customer_code)
    const [taxCode, setTaxCode] = useState(null)
    const [name, setName] = useState('')
    const [number, setNumber] = useState('');
    const [expiry_month, setExpiryMonth] = useState('')
    const [expiry_year, setExpiryYear] = useState('')
    const [cvv, setCvv] = useState('')
    const tkn = md5(customerId + 'oYmAIdtki%lu') 

    const isNumber = (n) => {return /^-?[\d.]+(?:e-?\d+)?$/.test(n);}

    const saveInfoCard = async (e) => {
        e.preventDefault(e)
        if(name.length  < 1 || number.length < 1 || expiry_month.length < 1 || expiry_year.length < 1 || cvv.length < 1) {
            alert('Completa tutti i campi')
        } else {
            if(isNumber(number) && isNumber(expiry_month) && isNumber(expiry_year) && isNumber(cvv)){
                const apiSaveCard = `https://my.revoluce.it/area_utente/gestione/api/customers/saveCard.php?name=${name}&number=${number}&expiry_month=${expiry_month}&expiry_year=${expiry_year}&cvv=${cvv}&customer_id=${customerId}&tkn_pvt=${tkn}`
                await axios.get(apiSaveCard).then(({data}) => {
                    if(data.success){
                        alert('Carta registrata con successo')
                        window.location.reload();
                    } else {
                        alert('Dati non validi')
                    }
                })
            } else {
                alert('Controlla i dati inseriti')
            }
        }
    }
    const saveInfoIban = async (e) => {
        e.preventDefault(e)
        if(name.length  < 1 || number.length < 1 || taxCode === null) {
            alert('Completa tutti i campi')
        } else {
            
            const apiSaveIban = `https://my.revoluce.it/area_utente/gestione/api/customers/saveIban.php?name=${name}&iban=${number}&customer_code=${customerCode}&tax_code=${taxCode}`
            await axios.get(apiSaveIban).then(({data}) => {
                alert('Carta registrata con successo')
                window.location.reload();
            })
        }
    }

    return (
        <div className="addMethod">
            <div className="back" onClick={() => navigate(-1)}>
                <p><ArrowBackIosIcon /> Indietro</p>
            </div>
            <Swiper
                slidesPerView={1} 
                grabCursor={true}
                pagination={true}
            >
                <SwiperSlide>
                    <div className="title">
                        <p>Carta di credito</p>
                    </div>
                    <div className="scorriLabel">
                        <p>Scorri per cambiare tipologia di pagamento</p>
                    </div>
                    <div className="inputs">
                        <form>
                            <div className="input">
                                <p className="label">Nome e Cognome</p>
                                <input type="text" placeholder="Es. Mario Rossi" onChange={(e) => setName(e.target.value)} />
                            </div>
                            <div className="input">
                                <p className="label">Numero carta</p>
                                <input type="number" placeholder="3333 2222 1111 1111" onChange={(e) => setNumber(e.target.value)} />
                            </div>
                            <div className="input two">
                                <div className="date">
                                    <p className="label">Data di scadenza</p>
                                    <input type="number" value={expiry_month} placeholder="09" onChange={(e) => e.target.value.length > 2 ? setExpiryMonth(e.target.value.slice(0,2)) : setExpiryMonth(e.target.value)} />
                                    /
                                    <input type="number" value={expiry_year} placeholder="22" onChange={(e) => e.target.value.length > 2 ? setExpiryYear(e.target.value.slice(0,2)) : setExpiryYear(e.target.value)} />

                                </div>
                                <div className="cvv">
                                    <p className="label">CVV</p>
                                    <input type="number" value={cvv} placeholder="722" onChange={(e) => e.target.value.length > 3 ? setCvv(e.target.value.slice(0,3)) : setCvv(e.target.value)} />
                                </div>
                            </div>
                            <div className="button">
                                <button type="submit" onClick={(e) => saveInfoCard(e)}>Conferma modalità di pagamento</button>
                            </div>
                        </form>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="title">
                        <p>Conto corrente</p>
                    </div>
                    <div className="scorriLabel">
                        <p>Scorri per cambiare tipologia di pagamento</p>
                    </div>
                    <div className="inputs">
                        <form>
                            <div className="input">
                                <p className="label">Nome e Cognome</p>
                                <input type="text" placeholder="Es. Mario Rossi" onChange={(e) => setName(e.target.value)} />
                            </div>
                            <div className="input">
                                <p className="label">IBAN</p>
                                <input type="text" placeholder="IT123992912299" onChange={(e) => setNumber(e.target.value)} />
                            </div>
                            <div className="input">
                                <p className="label">Codice Fiscale</p>
                                <input type="text" value={taxCode} placeholder="MMTPRT00A02E283N" onChange={(e) => setTaxCode(e.target.value.slice(0,16))} />
                            </div>
                            <div className="button">
                                <button type="submit" onClick={(e) => saveInfoIban(e)}>Conferma modalità di pagamento</button>
                            </div>
                        </form>
                    </div>
                </SwiperSlide>

            </Swiper>
        </div>
    )
}

export default AddMethod
